import { ColorRing } from "react-loader-spinner";
import styles from "./DropInput.module.css";
import { useEffect, useRef, useState } from "react";
import { helpers } from "@turf/turf";

export default function DropInput({
    recommendations,
    fetchRecommendations,
    setSelectedLocation,
    isLoading,
    setIsLoading,
    setIsMapping,
    selectedLocation,
    setInHelp,
    setRecommendations,
    triggerInputHouseNumber,
    setTriggerInputHouseNumber,
}) {
    const [address, setAddress] = useState(
        selectedLocation ? selectedLocation.address.label : ""
    );

    const [inputingHouseNumber, setInputingHouseNumber] = useState(false);

    const [inputFocused, setInputFocused] = useState(false);
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const [activeIndex, setActiveIndex] = useState(-1);

    const [isIphone, setIsIphone] = useState(
        /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream ? true : false
    );

    const timeoutRef = useRef(null);
    const dropInputRef = useRef(null);
    const inputRef = useRef(null);
    const selectedLocationRef = useRef(null);

    useEffect(() => {
        if (selectedLocation) {
            setAddress(selectedLocation.address.label);
            selectedLocationRef.current = selectedLocation;
        }
    }, [selectedLocation]);

    const handleClick = (e) => {
        if (!dropInputRef.current.contains(e.target)) {
            if (selectedLocationRef.current !== null) {
                setAddress(selectedLocationRef.current.address.label);
            }

            setInputFocused(false);
            setInputingHouseNumber(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, []);

    //dodaje razmak na upisivanju kućog broja
    useEffect(() => {
        if (triggerInputHouseNumber === true) {
            let input = inputRef.current;
            const street = selectedLocation.address.street;
            let indexOfStreet = input.value.indexOf(street) + street.length;

            setAddress(
                input.value.slice(0, indexOfStreet) +
                    " " +
                    input.value.slice(indexOfStreet)
            );
        }
    }, [triggerInputHouseNumber]);

    //kad se razmak doda onda se fokusira: fix za bacanje fokusa na kraj prilikom promjene inputa
    useEffect(() => {
        if (triggerInputHouseNumber === true) {
            let input = inputRef.current;
            const street = selectedLocation.address.street;
            let indexOfStreet = input.value.indexOf(street) + street.length;

            input.focus();

            input.setSelectionRange(indexOfStreet + 1, indexOfStreet + 1);

            setTriggerInputHouseNumber(false);
            setInputingHouseNumber(true);
        }
    }, [address]);

    const onAddressChange = async (e) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        const value = e.currentTarget.value;

        setRecommendations([]);
        setIsLoading(false);

        if (value.length >= 3) {
            setIsLoading(true);
            timeoutRef.current = setTimeout(async () => {
                fetchRecommendations(value);
            }, 500);
        }

        setActiveIndex(-1);
        setAddress(value);
    };

    const onRecommendationSelected = (i, resetFocus = false) => {
        if (selectedLocation && recommendations[i].title.includes(" bb,")) {
            setSelectedLocation((prevValue) => ({
                ...recommendations[i],
                position: prevValue.position,
            }));
        } else {
            setSelectedLocation(recommendations[i]);
        }
        setActiveIndex(i);
        setInHelp({
            title: "Provjera lokacije",
            description: `Kada ste zadovoljni s pozicijom kliknite na gumb "Provjeri dostupnost".`,
            active: false,
            quickTip: true,
            questions: [],
        });
        setIsMapping(true);

        if (inputingHouseNumber === false || resetFocus === true) {
            setInputFocused(false);
        }
    };

    // micanje po listi recommendationa z arrowima up & down
    const handleKeyDown = (e) => {
        if (inputFocused) {
            switch (e.key) {
                case "ArrowDown":
                    setActiveIndex((prevIndex) =>
                        prevIndex < recommendations.length - 1
                            ? prevIndex + 1
                            : 0
                    );
                    e.preventDefault();
                    break;
                case "ArrowUp":
                    setActiveIndex((prevIndex) =>
                        prevIndex > 0
                            ? prevIndex - 1
                            : recommendations.length - 1
                    );
                    e.preventDefault();
                    break;
                case "Enter":
                    if (activeIndex >= 0) {
                        onRecommendationSelected(activeIndex);
                    }
                    break;
                case "Escape":
                    setInputFocused(false);
                    setActiveIndex(-1);
                    break;
                default:
                    break;
            }
        }
    };

    useEffect(() => {
        if (
            recommendations[0] &&
            recommendations[0].resultType === "houseNumber" &&
            inputingHouseNumber === true
        ) {
            onRecommendationSelected(0);
        }
    }, [recommendations]);

    useEffect(() => {
        if (inputFocused) {
            window.addEventListener("keydown", handleKeyDown);
        } else {
            window.removeEventListener("keydown", handleKeyDown);
        }
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [inputFocused, recommendations, activeIndex]);

    return (
        <div
            ref={dropInputRef}
            className={`${styles.container} ${
                inputFocused &&
                !selectedLocation &&
                !isIphone &&
                styles[`container-mobile-focus`]
            } ${selectedLocation && styles[`container-after`]} `}
        >
            {!selectedLocation && (
                <div className={styles.title}>Provjera dostupnosti usluge</div>
            )}

            <input
                value={address}
                ref={inputRef}
                className={styles.input}
                onChange={onAddressChange}
                placeholder="Unesite željenu adresu..."
                onFocus={() => setInputFocused(true)}
            />

            <div
                className={`${styles.list} ${
                    inputFocused && styles[`list-open`]
                }`}
            >
                {recommendations &&
                    recommendations.map((el, i) => {
                        return (
                            <div
                                key={i}
                                data-value={el}
                                className={`${styles[`list-element`]} ${
                                    activeIndex === i &&
                                    styles[`selected-option`]
                                } ${
                                    inputFocused && styles[`list-element-open`]
                                }`}
                                onClick={() => {
                                    setInputingHouseNumber(false);
                                    onRecommendationSelected(i, true);
                                }}
                            >
                                {el.address.label}
                            </div>
                        );
                    })}
            </div>

            {address.length > 0 && (
                <svg
                    width="15"
                    height="15"
                    xmlns="http://www.w3.org/2000/svg"
                    className={styles.delete}
                    onClick={() => setAddress("")}
                >
                    <line
                        x1="2.25"
                        y1="1.5"
                        x2="12.75"
                        y2="13.5"
                        stroke="gray"
                        strokeWidth="2"
                    />
                    <line
                        x1="12.75"
                        y1="1.5"
                        x2="2.25"
                        y2="13.5"
                        stroke="gray"
                        strokeWidth="2"
                    />
                </svg>
            )}

            {isLoading && (
                <div className={`${styles[`loader`]} `}>
                    <ColorRing
                        visible={true}
                        height="inherit"
                        width="inherit"
                        ariaLabel="color-ring-loading"
                        wrapperClass="color-ring-wrapper"
                        colors={[
                            "#d6bfbf",
                            "#d6bfbf",
                            "#d6bfbf",
                            "#d6bfbf",
                            "#d6bfbf",
                        ]}
                    />
                </div>
            )}
        </div>
    );
}
